import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useDialogs } from '@work4all/components';

import { PromptResult } from '@work4all/models/lib/Enums/PromptResult.enum';
import { PromptType } from '@work4all/models/lib/Enums/PromptType.enum';

import { PriceGroupPickerField } from '../../../../../../../../../../components/entity-picker/PriceGroupPickerField';
import { ControllerPlus } from '../../../../../../../../form-plus/controller-plus';
import { useFormContextPlus } from '../../../../../../../../form-plus/use-form-context-plus';
import { useShadowServiceContractObjectApiContext } from '../../../../../hooks/use-shadow-service-contract-object-api-context';
import { ServiceContractPaymentData } from '../Components';

// ToDo: WW-7459 Move to shared shadow folder (+adjustment)
export const ServiceContractPriceGroupPicker = () => {
  const { t } = useTranslation();
  const { control } = useFormContextPlus<ServiceContractPaymentData>();

  const dialogs = useDialogs();

  const shadowServiceContractObjectApi =
    useShadowServiceContractObjectApiContext();
  const positions = shadowServiceContractObjectApi.positions;
  const promptResult = shadowServiceContractObjectApi.promptResult;

  return (
    <Box width="100px">
      <ControllerPlus
        name="priceGroup"
        control={control}
        render={({ field, fieldState }) => {
          return (
            <PriceGroupPickerField
              {...field}
              clearable={false}
              onChange={async (e) => {
                let confirmed = true;
                if (positions.length > 0) {
                  confirmed = await dialogs.confirm({
                    title: t('COMMON.CHANGE'),
                    description: t('ERP.GROUP_PICKER.CHANGE_QUESTION'),
                    confirmLabel: t('COMMON.YES'),
                    cancelLabel: t('ALERTS.BTN_ABORT'),
                  });
                }
                if (confirmed) {
                  promptResult.current.push({
                    result: PromptResult.YES,
                    type: PromptType.BZ_OBJECT_CHANGE_PRICE_GROUP_CHANGE_PRICE,
                  });
                  field.onChange(e);
                }
              }}
              error={fieldState?.error?.message}
            />
          );
        }}
      />
    </Box>
  );
};
